// src/utils/auth.js
export const setAuthToken = (token) => {
  localStorage.setItem('auth_token', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};

export const isAuthenticated = () => !!getAuthToken();

export const logout = () => {
  localStorage.removeItem('auth_token');
  // optionally: clear other user state or call backend logout endpoint
};

// NEW RAW JWT STORAGE (for backend requests)
export const setRawToken = (token) => {
  localStorage.setItem('raw_auth_token', token); // store raw JWT
};

export const getRawToken = () => {
  return localStorage.getItem('raw_auth_token'); // raw JWT for API calls
};

export const getAuthHeaders = () => {
  const token = getRawToken();
  return token
    ? { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    : { 'Content-Type': 'application/json' };
};
